import React, { useEffect, useState } from 'react'
import { GetNetProfitReportApi } from '../../../api/request/analytics';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton';
import columns from '../../../columns/AnalyticsAccounts';
import UserAvatar from '../../../components/global/avtar/UserAvatar';
import { render } from '@testing-library/react';
import Eye from '../../../assets/Eye';
import { useNavigate } from 'react-router-dom';

const ProfitableAccount = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const handleTableChange = (e) => {
        setCurrentPage(10 * e.current);
    };

    const getNetProfitReport = async () => {
        setIsLoading(true);
        try {
            const { data } = await GetNetProfitReportApi();
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            name: (<UserAvatar data={{ name: item?.name, email: item?.email, profileImage: item?.profileImage }} />),
                            netProfit: item?.netProfit.toFixed(2),
                            netProfitPercent: item?.netProfitPercent.toFixed(2),
                            closeProfit: item?.closeProfit.toFixed(2),
                            action: <button onClick={() => navigate(`/analytics/${item?.accountId}`)}><Eye /></button>
                        };
                    })
                );
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getNetProfitReport();
    }, []);

    return (
        <div className='max-h-[25rem] overflow-scroll'>
            <TableWithSkeleton
                columns={columns}
                data={data}
                loading={isLoading}
                pagination={true}
                onChange={handleTableChange}
                currentPage={currentPage}
            />
        </div>
    )
}

export default ProfitableAccount